import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/loading/Loader';
import NoResults from 'components/form/styling/NoResults';
import UserWalletsList from './UserWalletsList';
import { Card } from 'material-ui';
import styled from 'styled-components';

const StyledLoaderWrapper = styled(Card)`
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none !important;
    background: none !important;
    height: 25vh;
`;

const UserWalletsListContainer = (props) => {
    const { loadingWallets, wallets, refreshWallets } = props;

    if (loadingWallets) {
        return (
            <StyledLoaderWrapper>
                <Loader size={ 50 } />
            </StyledLoaderWrapper>
        );
    }

    if (!wallets.length) {
        return <NoResults label='resources.wallets.no_results' />;
    }

    return (
        <UserWalletsList wallets={ wallets } refreshWallets={ refreshWallets } />
    );
};

UserWalletsListContainer.propTypes = {
    loadingWallets: PropTypes.bool,
    refreshWallets: PropTypes.func.isRequired,
    wallets: PropTypes.arrayOf(PropTypes.shape({
        balance: PropTypes.number,
        currency: PropTypes.string,
        id: PropTypes.number,
    })).isRequired,
};

export default UserWalletsListContainer;



// WEBPACK FOOTER //
// ./src/pages/users/wallets/UserWalletsListContainer.js